import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ShopConfigurationBrandActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/ShopBrand/BrandBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationBrand"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationBrand"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ShopConfigurationBrandActivity)
